import { NavMarker } from 'react-rhumb';
import ChatAreaAlert from 'conversations-visitor-experience-components/visitor-widget/ChatAreaAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function ThreadHistoryError() {
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "UTV_ERROR",
    children: /*#__PURE__*/_jsx(ChatAreaAlert, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.network.pubSubFailure.title"
      }),
      onClose: () => {}
    })
  });
}
ThreadHistoryError.displayName = 'ThreadHistoryError';
export default ThreadHistoryError;